/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : editRequestApi.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";

const editRequestAPI = {

  get_edit_requests: {
    api_name: "/PCM/project/edit/requests",
    https_method: "GET",
    action_type: actionType.GET_EDIT_REQUESTS,
    description: "Get the Edit Requests",
  },

  create_edit_requests: {
    api_name: "/PCM/project/edit/request",
    https_method: "POST",
    action_type: actionType.CREATE_EDIT_REQUESTS,
    description: "Create the Edit Requests",
  },

  approve_edit_requests: {
    api_name: "/PCM/project/edit/request/approve",
    https_method: "PUT",
    action_type: actionType.APPROVE_EDIT_REQUESTS,
    description: "Approve the Edit Requests",
  },

  reject_edit_requests: {
    api_name: "/PCM/project/edit/request/reject",
    https_method: "PUT",
    action_type: actionType.REJECT_EDIT_REQUESTS,
    description: "Reject the Edit Requests",
  },
};

export default editRequestAPI;
